module.exports = __webpack_public_path__ + "static/TruenoLt-69f0ed8e86b1b84b36e19af903252c6b.woff";